const base64URLEncode = (buffer) => {
  const base64 = btoa(String.fromCharCode.apply(null, buffer));
  
  return base64
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=/g, "");
};

const generateCodeVerifier = () => {
  const array = new Uint8Array(32);
  window.crypto.getRandomValues(array);
  return base64URLEncode(array);
};

const generateCodeChallengeFromVerifier = (verifier) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(verifier);
  
  return window.crypto.subtle.digest("SHA-256", data).then((hashBuffer) => {
    return base64URLEncode(new Uint8Array(hashBuffer));
  });
};

export const generatePKCEPair = async () => {
  const codeVerifier = generateCodeVerifier();
  const codeChallenge = await generateCodeChallengeFromVerifier(codeVerifier);
  return { codeVerifier, codeChallenge };
};

export const createOAuthPopup = async ({
  authUrl,
  popupTitle,
  successMessageType,
  errorMessageType,
  providerName,
  codeVerifier,
}) => {

  return new Promise((resolve, reject) => {
    const popup = window.open(
      authUrl,
      popupTitle,
      "width=600,height=700,left=200,top=100",
    );

    if (!popup) {
      reject(new Error("Failed to open popup. Please allow popups for this site."));
      return;
    }

    const messageListener = (event) => {
      if (event.origin !== window.location.origin) {
        return;
      }

      if (event.data.type === successMessageType) {
        window.removeEventListener("message", messageListener);
        popup.close();
        resolve({ 
          code: event.data.payload.code,
          codeVerifier, 
        });
      } else if (event.data.type === errorMessageType) {
        window.removeEventListener("message", messageListener);
        popup.close();
        reject(new Error(event.data.error || `${providerName} authentication failed`));
      }
    };

    window.addEventListener("message", messageListener);

    const popupCheckInterval = setInterval(() => {
      if (popup.closed) {
        clearInterval(popupCheckInterval);
        window.removeEventListener("message", messageListener);
        reject(new Error("Authentication cancelled"));
      }
    }, 500);
  });
};

export const buildOAuthUrl = (baseUrl, params) => {
  const url = new URL(baseUrl);
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      url.searchParams.append(key, value);
    }
  });
  return url.toString();
};

export const parseCodeFromQuery = (providerName) => {
  const params = new URLSearchParams(window.location.search);

  const code = params.get("code");
  const error = params.get("error");
  const errorDescription = params.get("error_description");

  if (error) {
    return { error, errorDescription };
  }

  if (!code) {
    return { 
      error: "missing_code", 
      errorDescription: `No authorization code received from ${providerName}`, 
    };
  }

  return { code };
};

